import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessBoardEmbedRoute: InvariantJiraRoute = {
	name: 'classic-business-board-embed',
	path: '/jira/core/projects/:projectKey/board/embed',
	exact: true,
};
